export default __webpack_public_path__ + "f46d0797ebcc6ad81c93864d73cf6f62.svg";